import { createContext, useState, ReactNode } from "react";

declare global {
    interface Window {
        _AMapSecurityConfig?: {
            securityJsCode: string;
        };
    }
}

export interface IMapContext {
    AMap: any;
    setAMap: (value: any) => void;
    map: any;
    setMap: (value: any) => void;
}

// createContext 的默认值 —— 必须提供所有字段
export const MapContext = createContext<IMapContext>({
    AMap: null,
    setAMap: () => { },
    map: null,
    setMap: () => { },
});

// Provider 类型
interface ProviderProps {
    children: ReactNode;
}

export const MyProvider = ({ children }: ProviderProps) => {
    const [map, setMap] = useState<any>(null);
    const [AMap, setAMap] = useState<any>(null);

    window._AMapSecurityConfig = {
        securityJsCode: "1ff8751ba0f4086ec444b1acbb56f14a",
    };

    return (
        <MapContext.Provider
            value={{
                AMap,
                setAMap,
                map,
                setMap,
            }}
        >
            {children}
        </MapContext.Provider>
    );
};
